import { connectBaseApi, contractClient, createRpcMutation, createRpcQuery } from "@racoon/api";

export const contractGrpc = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    createContract: createRpcMutation(build, contractClient, "createContract", {
      invalidatesTags: ["Contracts", "ContainerGroup", { type: "Company", id: "LIST" }],
    }),
    updateContract: createRpcMutation(build, contractClient, "updateContract", {
      // PickupLocation: a location embeds its BY_NORM contracts (subscriptionContracts).
      // Company LIST: counterparty status is derived from contract status.
      invalidatesTags: [
        "Contracts",
        "ContainerGroup",
        "PickupLocation",
        { type: "Company", id: "LIST" },
      ],
    }),
    archiveContract: createRpcMutation(build, contractClient, "archiveContract", {
      // PickupLocation: a location embeds its BY_NORM contracts (subscriptionContracts).
      // Company LIST: counterparty status is derived from contract status.
      invalidatesTags: [
        "Contracts",
        "ContainerGroup",
        "PickupLocation",
        { type: "Company", id: "LIST" },
      ],
    }),
    getContract: createRpcQuery(build, contractClient, "getContract"),
    listContracts: createRpcQuery(build, contractClient, "listContracts", {
      providesTags: ["Contracts"],
    }),
    uploadContractFiles: createRpcMutation(build, contractClient, "uploadContractFiles", {
      invalidatesTags: ["Contracts"],
    }),
    deleteContractFiles: createRpcMutation(build, contractClient, "deleteContractFiles", {
      invalidatesTags: ["Contracts"],
    }),
  }),
  overrideExisting: false,
});
export const {
  useCreateContractMutation,
  useUpdateContractMutation,
  useArchiveContractMutation,
  useGetContractQuery,
  useLazyGetContractQuery,
  useListContractsQuery,
  useLazyListContractsQuery,
  useUploadContractFilesMutation,
  useDeleteContractFilesMutation,
} = contractGrpc;
